var LoyaltyCardType;
(function(LoyaltyCardType) {
    LoyaltyCardType["LUHN"] = "LUHN";
    LoyaltyCardType["UUID"] = "UUID";
})(LoyaltyCardType || (LoyaltyCardType = {}));

export { LoyaltyCardType };
//# sourceMappingURL=types.js.map
